export default __webpack_public_path__ + "static/new_biz_revenue-9f88dc432745f71ba44dbcb97434cec3.png";